import { IconName } from 'src/types/generated-icons'

import cn from '@/utils/cn'

export type FlagNames =
  | 'aExpress'
  | 'applePay'
  | 'elo'
  | 'googlePay'
  | 'hipercard'
  | 'mastercard'
  | 'pix'
  | 'qrCode'
  | 'samsungPay'
  | 'visa'
export type IconFooterNames =
  | 'logo_stoneco'
  | 'logo-facebook'
  | 'logo-instagram'
  | 'logoTon'
  | 'logoTon_green'
  | 'logo-twitter'
  | 'logo-youtube'
  | 'pagar-me'
  | 'stone'

export type IconSolutionsHeaderNames =
  | 'phone-heart'
  | 'phone-card'
  | 'shopping-cart'
  | 'qr-code'
  | 'cent-hand'
  | 'signal-contactless'
  | 'dollar-phone'
  | 'treasure-chest'

interface RootSprite<T> {
  name: T
  className?: string
}

interface BaseSpriteFn<T> extends RootSprite<T> {
  spriteName: string
}

const BaseSpriteFunction = <T,>({
  spriteName,
  name,
  className = ''
}: BaseSpriteFn<T>) => {
  return (
    <svg className={cn(className)}>
      <use xlinkHref={`/${spriteName}.svg#${name}`} />
    </svg>
  )
}

export const IconSprite = (
  props: RootSprite<IconName> & { spriteName: string }
) =>
  BaseSpriteFunction({
    className: cn('fill-current', props.className),
    ...props
  })

export const FlagSprite = (props: RootSprite<FlagNames>) =>
  BaseSpriteFunction({
    spriteName: 'bandeiras',
    className: cn(props.className, 'fill-current'),
    ...props
  })

export const FooterSprite = (props: RootSprite<IconFooterNames>) =>
  BaseSpriteFunction({ spriteName: 'sprite-footer', ...props })
